import { Logo, Sidebar } from '@nrg/design-system';
import type { AccessLevel } from '@/auth/iam';

import { resolveBrand } from './brands';

interface SidebarBrandLogoProps {
  /** The caller's IAM scope. `undefined` while IAM is unresolved → fallback. */
  access: AccessLevel | undefined;
}

/**
 * The sidebar lockup: the caller's tenant logo when their tenant is
 * white-labelled, otherwise the NRG mark (see `brands.ts` for the rule).
 *
 * The tenant logo *replaces* the NRG mark — only the `CMX` subtitle stays, so
 * the product is still named. `Sidebar.Logo`'s own `src` slot is what renders
 * the image: it boxes any aspect ratio at `height: 40px; object-fit: contain`,
 * so a wide wordmark and a square mark both sit correctly without per-client CSS.
 *
 * There is no flash of the wrong logo: the layout renders `LoadingShell` until
 * IAM resolves, so this only ever mounts with the scope already known.
 */
export function SidebarBrandLogo({ access }: SidebarBrandLogoProps) {
  const brand = resolveBrand(access);

  return (
    <Sidebar.Logo
      subtitle="CMX"
      href="#"
      {...(brand ? { src: brand.logoUrl, alt: brand.name } : {})}
    >
      {brand ? null : <Logo variant="group" size={50} />}
    </Sidebar.Logo>
  );
}
